import { render, staticRenderFns } from "./PageSection.vue?vue&type=template&id=540e92e9&"
import script from "./PageSection.vue?vue&type=script&lang=js&"
export * from "./PageSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports